"use strict";
import { RingTimePeriod, TimePeriod } from "appGraphql/data/util";
import { atom, useAtom } from "jotai";
import { atomWithReset, useUpdateAtom } from "jotai/utils";
import { useCallback } from "react";
export var TokenSortMethod = /* @__PURE__ */ ((TokenSortMethod2) => {
  TokenSortMethod2["FULLY_DILUTED_VALUATION"] = "FDV";
  TokenSortMethod2["PRICE"] = "Price";
  TokenSortMethod2["VOLUME"] = "Volume";
  TokenSortMethod2["HOUR_CHANGE"] = "1 hour";
  TokenSortMethod2["DAY_CHANGE"] = "1 day";
  return TokenSortMethod2;
})(TokenSortMethod || {});
export var RingTokenSortMethod = /* @__PURE__ */ ((RingTokenSortMethod2) => {
  RingTokenSortMethod2["TOTAL_VALUE_LOCKED"] = "TVL";
  RingTokenSortMethod2["PRICE"] = "Price";
  RingTokenSortMethod2["VOLUME"] = "Volume";
  RingTokenSortMethod2["HOUR_CHANGE"] = "1 hour";
  RingTokenSortMethod2["DAY_CHANGE"] = "1 day";
  return RingTokenSortMethod2;
})(RingTokenSortMethod || {});
export const exploreSearchStringAtom = atomWithReset("");
export const filterTimeAtom = atom(TimePeriod.DAY);
export const filterRingTimeAtom = atom(RingTimePeriod.DAY);
export const sortMethodAtom = atom("Volume" /* VOLUME */);
export const sortRingMethodAtom = atom("Volume" /* VOLUME */);
export const sortAscendingAtom = atom(false);
export function useSetSortMethod(newSortMethod) {
  const [sortMethod, setSortMethod] = useAtom(sortMethodAtom);
  const setSortAscending = useUpdateAtom(sortAscendingAtom);
  return useCallback(() => {
    if (sortMethod === newSortMethod) {
      setSortAscending((sortAscending) => !sortAscending);
    } else {
      setSortMethod(newSortMethod);
      setSortAscending(false);
    }
  }, [sortMethod, setSortMethod, setSortAscending, newSortMethod]);
}
export function useSetSortRingMethod(newSortMethod) {
  const [sortMethod, setSortMethod] = useAtom(sortRingMethodAtom);
  const setSortAscending = useUpdateAtom(sortAscendingAtom);
  return useCallback(() => {
    if (sortMethod === newSortMethod) {
      setSortAscending((sortAscending) => !sortAscending);
    } else {
      setSortMethod(newSortMethod);
      setSortAscending(false);
    }
  }, [sortMethod, setSortMethod, setSortAscending, newSortMethod]);
}
